(function () {
    "use strict";

    angular.module("app").factory("apiClientFactory", ApiClientFactory);

    ApiClientFactory.$inject = ["$http", "settingsService", "saveAs",];
    function ApiClientFactory($http, settingsService, saveAs) {

        return {
            put: route => withPayload(route, $http.put),
            patch: route => withPayload(route, $http.patch),
            post: route => withPayload(route, $http.post),

            get: route => withParameter(route, $http.get),
            delete: route => withParameter(route, $http.delete),

            getFile: route => getFile(route),
            postFile: route => file(route, $http.post),
            patchFile: route => file(route, $http.patch),
        };

        function withPayload(route, method) {
            return function (payload, successCallback, errorCallback, finallyCallback, options) {

                const url = settingsService.applicationPath + route;

                return method(url, payload, options)
                    .then(onSuccess, errorCallback)
                    .finally(finallyCallback);

                function onSuccess(result) {
                    if (result.headers("HabilFileName"))
                        saveFile(result);
                    else
                        return successCallback(result);
                }
            };
        }

        function withParameter(route, method) {
            return function (parameter, successCallback, errorCallback, finallyCallback, options) {

                let url = settingsService.applicationPath + route;
                if (parameter)
                    url += encodeURIComponent(parameter);

                return method(url, options)
                    .then(onSuccess, errorCallback)
                    .finally(finallyCallback);

                function onSuccess(result) {
                    if (result.headers("HabilFileName"))
                        saveFile(result);
                    else
                        successCallback(result);
                }
            };
        }

        function getFile(route) {
            return function (parameter, errorCallback, finallyCallback) {

                let url = settingsService.applicationPath + route;
                if (parameter)
                    url += encodeURIComponent(parameter);

                return $http.get(url, { responseType: "arraybuffer" })
                    .then(saveFile, errorCallback)
                    .finally(finallyCallback);
            };
        }

        function file(route, method) {
            return function (payload, errorCallback, finallyCallback) {
                const url = settingsService.applicationPath + route;

                return method(url, payload, { responseType: "arraybuffer" })
                    .then(saveFile, errorCallback)
                    .finally(finallyCallback);
            };
        }

        function saveFile(result) {
            if (!CheckResultReceived(result))
                throw new Error("Invalid response");

            const file = new Blob([result.data]);
            saveAs(file, decodeURIComponent(result.headers("HabilFileName")));
        }
    }
})();
